<div class="p-4">
    <div class="mb-2">
        <p-skeleton width="5rem" height="2rem"></p-skeleton>
    </div>
    <div>
        <p-skeleton width="10rem"></p-skeleton>
    </div>
</div>